import { MasterImport } from './Import'
const { RoutesMap, CountryList, StateList, DistrictList, TehsilList, CityList, CategoryList, SubCategoryList, ServiceList, PlanList, DesignationList, ExpenseCategoryList } = MasterImport

const MasterRoute = () => {
    return [
        {
            path: RoutesMap.COUNTRY_LIST.path,
            element: <CountryList />
        },

        {
            path: RoutesMap.STATE_LIST.path,
            element: <StateList />
        },

        {
            path: RoutesMap.DISTRICT_LIST.path,
            element: <DistrictList />
        },

        {
            path: RoutesMap.TEHSIL_LIST.path,
            element: <TehsilList />
        },

        {
            path: RoutesMap.CITY_LIST.path,
            element: <CityList />
        },

        {
            path: RoutesMap.CATEGORY_LIST.path,
            element: <CategoryList />
        },

        {
            path: RoutesMap.SUB_CATEGORY_LIST.path,
            element: <SubCategoryList />
        },

        {
            path: RoutesMap.SERVICE_LIST.path,
            element: <ServiceList />
        },

        {
            path: RoutesMap.PLAN_LIST.path,
            element: <PlanList />
        },

        {
            path: RoutesMap.DESIGNATION_LIST.path,
            element: <DesignationList />
        },

        {
            path: RoutesMap.EXPENSE_CATEGORY_LIST.path,
            element: <ExpenseCategoryList />
        },
    ]
}

export default MasterRoute;